import { FormDataConsumer, required } from "react-admin";
import React from "react";
import { get } from "lodash";
import { ReferenceAutocompleteInput } from "ra-friendsofbabba";

const UniversityInput = ({ visible, ...props }) => (
  <FormDataConsumer {...props}>
    {({ formData }) => {
      const roles = get(formData, "roles", []);
      if (!visible && !roles.find((role) => role.id === 5 || role.id === 8)) {
        return null;
      }
      const filter = roles.some((role) => role.id === 8)
        ? { connected: true }
        : null;
      return (
        <ReferenceAutocompleteInput
          {...props}
          validate={required()}
          perPage={1000}
          filter={filter}
          sort={{ field: "name", order: "ASC" }}
          reference="universities"
          optionText="name"
        />
      );
    }}
  </FormDataConsumer>
);
export default UniversityInput;
